// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 269 ? "0b7b90cd" : chunkId) + "." + {"194":"f8f466381bb645ca","269":"27a8f25a73979ff8"}[chunkId] + ".js";
};